import {FormElementType} from "~/enums/formElementType";
import {ObjectModelPropertyRootType, ObjectModelPropertyType} from "~/enums/objectModelPropertyType";

export const CompatibleMultiSelect: Array<FormElementType | ObjectModelPropertyType> = [
  FormElementType.checkboxGroup,
  FormElementType.dropdown,
  FormElementType.radioButtonGroup,
  ObjectModelPropertyRootType.PickList,
]

export const CompatibleDates: Array<FormElementType | ObjectModelPropertyType> = [
  FormElementType.dateTimePicker,
  ObjectModelPropertyRootType.DateTime,
]

export const CompatibleNumbers: Array<FormElementType | ObjectModelPropertyType> = [
  FormElementType.textField,
  ObjectModelPropertyRootType.Number,
]

export const CompatibleTexts: Array<FormElementType | ObjectModelPropertyType> = [
  FormElementType.textField,
  ObjectModelPropertyRootType.Text,
]